

































import { defineComponent, ref } from "@vue/composition-api";
import useCoreHistory from "@/store/useCoreHistory";
import moment from 'moment-timezone';
import useUserSettings from "@/store/useUserSettings";
import UserSettingsViewModel from "@/models/UserSettingsViewModel";

export default defineComponent({
    setup(_, context) {
        const { getUserSettings } = useUserSettings();
        const userSettings = ref<UserSettingsViewModel>();
        getUserSettings().then((value: UserSettingsViewModel) => {
            userSettings.value = value;
        });

        const { logItems } = useCoreHistory();

        const formatModifiedDate = (modifiedDate) => {
            return moment.utc(modifiedDate).tz(userSettings.value.timezone).format("MMM DD, YYYY HH:mm:ss");
        };

        return {
            logItems,
            formatModifiedDate
        };
    }
});
